import { destroy,mutate,query, update } from "../../defaults/fetch";
import {useState,useEffect} from "react";


export const useGetAllTaxes = (flag)=>{
    const [taxes,setTaxes] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const getAllTaxes = async()=>{
            setLoading(true)
            const url = `tax/get-all`;
            const {data} = await query(url);
            setLoading(false);
            setTaxes(data);
        }
        getAllTaxes();
    },[flag])

    return {loading,taxes};
}


export const useCreateTax = ()=>{
    const createTax = async(body)=>{
        const url = `tax/create`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return createTax;
}

export const useUpdateTax = ()=>{
    const updateTax = async(id,body)=>{
        const url = `tax/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateTax;
}



export const useDeleteTax = ()=>{
    const deleteTax = async(id)=>{
        const url = `tax/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteTax;
}